import EnquriesList from './EnquiriesList';
import EnquiriesEdit from './EnquiriesEdit';
import EnquiriesReport from './EnquiriesReport';

export default {
    list: EnquriesList,
    edit: EnquiriesEdit,
    report: EnquiriesReport,
};
